import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Country, CountryService, ListOfCountry } from "../../../../swaggerServices";
import { Subscription } from 'rxjs';
import { ConfigStateService } from '../../config/config-state.service';
import { TranslocoService } from '@jsverse/transloco';
import { TenantConfigService } from '../../../shared/services/tenant-config.service';
import { ClientNotificationService } from '../../client-notification.service';
import { AddUpdateCountryComponent } from './add-update-country/add-update-country.component';

declare var $: any;

interface ICountry extends Country {
  displayUpdatedAt?: string;
  displayCreatedAt?: string;
  selected?: boolean;
}
@Component({
    selector: 'app-countries',
    templateUrl: './countries.component.html',
    styleUrls: ['./countries.component.scss'],
    standalone: false
})

export class CountriesComponent implements OnInit {

  @ViewChild('addUpdateCountryTypeModal')
  addUpdateCountryModal: ElementRef;

  @ViewChild('msgModal')
  msgModal: ElementRef;
  @ViewChild("configExportConfimationModal")
  configExportConfimationModal: ElementRef;

  subscriptions: Subscription[] = [];
  countries: ListOfCountry;
  countriesForConfigImport: ICountry[];
  selectedCountries = [];
  entireListSelected = false;

  countrySearch: string = "";
  uiConfig: TenantConfigService;
  countryAlias: string;
  configExportMode = false;

  constructor(private countryService: CountryService,
    private config: ConfigStateService,
    private clientNotificationService: ClientNotificationService,
    private translocoService: TranslocoService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.countryService.getCountrys().subscribe((countries: any) => {
      this.countries = countries;
      this.loadCountriesForConfigExport();
    });
    this.config.loadConfig().subscribe(config => {
      this.uiConfig = new TenantConfigService(config);
      this.countryAlias = this.uiConfig.config.countryAlias
      this.translocoService.selectTranslate('country-alias').subscribe(value => this.countryAlias = value);
    })
  };

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  edit(country) {
    this.openAddUpdateCountryDialog(country);
  }

  add() {
    this.openAddUpdateCountryDialog(null);
  }

  refresh() {
    this.countryService.getCountrys().subscribe((countries: any) => {
      this.countries = countries;
    });
  }

  toggleConfigExportMode() {
    this.configExportMode = !this.configExportMode;
  }

  loadCountriesForConfigExport() {
    this.countriesForConfigImport = [];
    this.countries.forEach(country => {
      this.countriesForConfigImport.push({
        displayUpdatedAt: country.updatedAt,
        displayCreatedAt: country.createdAt,
        selected: false,
        ...country
      });
    });
  }

  entireListSelection() {
    this.countriesForConfigImport.forEach((templateType) => {
      templateType.selected = this.entireListSelected;
    });
  }

  listSelection() {
    this.countriesForConfigImport.forEach((t) => {
      if (t.selected === false) return this.entireListSelected = false;
    });
  }

  openConfigExportConfimationModal() {
    this.selectedCountries = this.countriesForConfigImport.map((country) => {
      if (country.selected) { return { countryName: country.countryName, displayUpdatedAt: country.displayUpdatedAt }; }
    }).filter(country => country);
    $(this.configExportConfimationModal.nativeElement).modal("show");
  }

  downloadConfig() {
    const ids = this.countriesForConfigImport.map((c) => {
      if (c.selected) { return c.id; }
    }).filter(x => x);
    this.countryService.downloadConfigExportCountry({ countryIds: ids }).subscribe(data => {
      if (!data.fileContent) {
        this.clientNotificationService.appendMessage("File couldn't be fetched, please try again later", "Download config", false);
        return;
      }
      var elem = window.document.createElement('a');
      elem.href = "data:application/json," + encodeURIComponent(data.fileContent);
      elem.download = data.fileName ? data.fileName : "package";
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
      this.clearSelectedCountries();
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    }, error => {
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    });
  }

  private clearSelectedCountries() {
    this.countriesForConfigImport.forEach(tt => tt.selected = false);
  }

  private openAddUpdateCountryDialog(country: Country | null) {
    this.dialog.open(AddUpdateCountryComponent, {
      width: '520px',
      data: country,
      autoFocus: 'input',
    }).afterClosed().subscribe(updated => {
      if (updated) {
        this.refresh();
      }
    });
  }
}
